import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const ReferralManager = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const referralCode = searchParams.get('ref');
    
    console.log('🔍 ReferralManager - Détection de ?ref=');
    console.log('URL complète:', window.location.href);
    console.log('Paramètre "ref":', referralCode);
    
    if (referralCode) {
      console.log('✅ Code détecté! Validation en cours...');
      
      // Validation basique du code referral
      if (!isValidReferralCode(referralCode)) {
        console.warn('❌ Invalid referral code format. Format accepté: alphanumérique, 3-50 caractères');
        console.warn('Code reçu:', referralCode);
        return;
      }

      // Vérifier s'il y a déjà un referrer
      const existingRef = localStorage.getItem('referrer_code');
      if (existingRef) {
        console.info('ℹ️ Ancien referrer détecté:', existingRef);
        console.info('🔄 Remplacement par le nouveau code:', referralCode);
      }

      // Stocker le code referral (remplace l'ancien s'il existe)
      storeReferralCode(referralCode);
      console.log('✅ Referral code stored:', referralCode);
    } else {
      console.log('ℹ️ Pas de paramètre ?ref= détecté');
    }
  }, [searchParams]);

  return null; // Composant invisible
};

// Validation du format du code referral
const isValidReferralCode = (code) => {
  // Alphanumérique seulement, 3-50 caractères
  return /^[a-zA-Z0-9_-]{3,50}$/.test(code);
};

// Stocker le code referral de façon sécurisée
const storeReferralCode = (code) => {
  const timestamp = new Date().toISOString();
  const deviceFingerprint = generateDeviceFingerprint();
  
  const referralData = {
    code,
    timestamp,
    deviceFingerprint,
    userAgent: navigator.userAgent,
  };

  console.log('📝 Stockage du code de parrainage...');
  console.log('Code:', code);
  console.log('Timestamp:', timestamp);
  console.log('Device Fingerprint:', deviceFingerprint);

  // Stocker en localStorage
  localStorage.setItem('referrer_code', code);
  localStorage.setItem('referrer_data', JSON.stringify(referralData));

  // Vérifier que ça a été stocké
  console.log('✅ localStorage "referrer_code":', localStorage.getItem('referrer_code'));
  console.log('✅ localStorage "referrer_data":', localStorage.getItem('referrer_data'));

  // Créer un cookie sécurisé (sera complété en production avec signature)
  setSecureReferralCookie(code);
  
  // Vérifier les cookies
  console.log('🍪 Tous les cookies:', document.cookie);
};

// Générer une empreinte device pour détecter les fraudes
const generateDeviceFingerprint = () => {
  const data = [
    navigator.userAgent,
    navigator.language,
    navigator.hardwareConcurrency,
    navigator.deviceMemory,
    navigator.maxTouchPoints,
    screen.width + 'x' + screen.height,
    screen.colorDepth,
  ].join('|');

  // Simple hash (en production, utiliser une vraie fonction de hash)
  return btoa(data);
};

// Définir un cookie sécurisé (HttpOnly en production)
const setSecureReferralCookie = (code) => {
  const expirationDays = 30;
  const date = new Date();
  date.setTime(date.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
  
  // En développement seulement - en production, la signature se fait côté backend
  const cookieString = `referrer_code=${encodeURIComponent(code)}; expires=${date.toUTCString()}; path=/; Secure; SameSite=Strict`;
  
  console.log('🍪 Création du cookie:');
  console.log('Cookie string:', cookieString);
  console.log('Expiration:', date.toUTCString());
  
  document.cookie = cookieString;
  
  // Vérifier que le cookie a été créé
  setTimeout(() => {
    console.log('🍪 Vérification du cookie après création:');
    console.log('document.cookie:', document.cookie);
    if (document.cookie.includes('referrer_code')) {
      console.log('✅ Cookie "referrer_code" trouvé!');
    } else {
      console.warn('⚠️ Cookie "referrer_code" NOT FOUND! Vérife les paramètres Secure/SameSite');
    }
  }, 100);
};

// Récupérer le code referral pour le paiement
export const getReferralCode = () => {
  return localStorage.getItem('referrer_code') || null;
};

// Récupérer les données referral complètes (pour debug)
export const getReferralData = () => {
  const data = localStorage.getItem('referrer_data');
  return data ? JSON.parse(data) : null;
};

// Fonction pour appeler l'API lors d'un paiement réussi
export const logReferralConversion = async (userId, price_id) => {
  const referralCode = getReferralCode();
  
  if (!referralCode) {
    console.info('❌ Pas de code referral - pas de commission');
    return;
  }

  const referralData = getReferralData();

  try {
    const response = await fetch('/api/referrals/conversion', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('access_token')}`
      },
      body: JSON.stringify({
        referrer_code: referralCode,
        user_id: userId,
        price_id,
        timestamp: new Date().toISOString(),
        device_fingerprint: referralData?.deviceFingerprint,
        user_agent: referralData?.userAgent,
      })
    });

    if (response.ok) {
      const result = await response.json();
      console.log('✅ Referral conversion logged:', result);
      return result;
    } else {
      console.error('❌ Erreur logging referral:', response.status);
    }
  } catch (error) {
    console.error('❌ Erreur API referral:', error);
  }
};

// Fonction générique pour logger un événement d'affiliation (signup, abonnement, etc)
export const logReferralEvent = async ({
  event = 'signup',
  userId,
  price_id = null,
  ip = null,
  timestamp = null
} = {}) => {
  console.log('📤 logReferralEvent() appelée');
  console.log('Paramètres:', { event, userId, price_id, ip, timestamp });
  
  const referralCode = getReferralCode();
  
  console.log('Code parrainage récupéré:', referralCode);
  
  if (!referralCode) {
    console.info('ℹ️ Pas de code parrainage - aucun tracking');
    return null;
  }

  const referralData = getReferralData();
  console.log('Données parrainage récupérées:', referralData);
  

  // Forcer ip à '0.0.0.0' si non défini
  const payload = {
    codeParrain: referralCode,
    userId,
    event,
    ip: (ip !== null && ip !== undefined) ? ip : '0.0.0.0',
    userAgent: referralData?.userAgent || navigator.userAgent,
    fingerprint: referralData?.deviceFingerprint,
    price_id,
    timestamp: timestamp || Date.now()
  };

  console.log('📦 Payload à envoyer:', JSON.stringify(payload, null, 2));

  try {
    console.log('🌐 Envoi du POST à: https://lrv7zfe6dc7hrpucp3qulxlzaq0fszlw.lambda-url.eu-west-3.on.aws/tools/affiliation/track');
    
    const response = await fetch('https://lrv7zfe6dc7hrpucp3qulxlzaq0fszlw.lambda-url.eu-west-3.on.aws/tools/affiliation/track', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('access_token')}`
      },
      body: JSON.stringify(payload)
    });

    console.log('📊 Réponse reçue - Status:', response.status);
    console.log('Headers réponse:', Object.fromEntries(response.headers.entries()));

    if (response.ok) {
      const result = await response.json();
      console.log('✅ Affiliation event logged:', result);
      return result;
    } else {
      const errorText = await response.text();
      console.error('❌ Erreur affiliation event:', response.status);
      console.error('Réponse d\'erreur:', errorText);
      return null;
    }
  } catch (error) {
    console.error('❌ Erreur API affiliation:', error);
    console.error('Message:', error.message);
    console.error('Stack:', error.stack);
    return null;
  }
};
